// this is full screen loading 

import * as React from 'react'
import { Navbar } from "./../sections"
import Footer from './../../footer'
import "./../../style/loading.module.css"

const LoadingFullScreen = () => {
    return (
        <>
            <Navbar />
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "45vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                <div className="st-spinner" /></div>
            <Footer />
        </>
    )
}

export default LoadingFullScreen


type props = {
    loading: boolean
}

export const LoadingFullScreenTransparent = (props: props) => {
    return (
        <div className={`loading-overlay ${props.loading ? 'is-active' : ''}`}>
            <span className="fas fa-spinner fa-3x fa-spin"></span>
        </div>
    )
}